import React from 'react'
import AyudaExportar from './ayuda-exportar'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList } from 'recharts'

// Resalta la franja del proveedor bajo el mouse: indica dónde se puede hacer clic.
const CURSOR_FILA = { fill: 'rgba(29, 111, 66, 0.12)' }

/**
 * Casos activos por proveedor.
 * Con `onExportar(responsableId)`, cada barra descarga los casos que representa (RG-602).
 */
const CasosActivosPorProveedor = ({ data = [], onExportar }) => {
    if (!data.length) return <div className='text-center text-muted py-5'>Sin datos</div>

    // El alto crece con la cantidad de proveedores para que las barras no se aplasten.
    const altura = Math.max(220, data.length * 38)

    const alClic = (barra) => {
        const fila = barra?.payload ?? barra
        if (onExportar && fila?.responsableId) onExportar(fila.responsableId)
    }

    // Una barra de pocos casos mide un par de píxeles al lado de una de 1.886: casi imposible acertarle.
    // Por eso TODA la franja del proveedor es clicable. Un clic justo sobre la barra lo atiende antes su
    // propio `onClick` y esta función ya no hace nada (el hook ignora la 2.ª llamada mientras exporta).
    const alClicFila = (estado) => {
        const fila = estado?.activePayload?.[0]?.payload
        if (onExportar && fila?.responsableId) onExportar(fila.responsableId)
    }

    return (
        <div>
            {onExportar && (
                <AyudaExportar texto='Clic en una barra, o junto a ella, para descargar sus casos en Excel' />
            )}
            <ResponsiveContainer width='100%' height={altura}>
                <BarChart
                    data={data}
                    layout='vertical'
                    margin={{ top: 5, right: 50, left: 10, bottom: 5 }}
                    onClick={alClicFila}
                    style={{ cursor: onExportar ? 'pointer' : undefined }}
                >
                    <CartesianGrid strokeDasharray='3 3' horizontal={false} />
                    <XAxis type='number' tick={{ fontSize: 11 }} allowDecimals={false} />
                    <YAxis type='category' dataKey='responsable' tick={{ fontSize: 11 }} width={160} />
                    <Tooltip
                        cursor={onExportar ? CURSOR_FILA : undefined}
                        formatter={(value) => [value, 'Casos activos']}
                        contentStyle={{ fontSize: 12 }}
                    />
                    <Bar
                        dataKey='casosActivos'
                        fill='#4F517A'
                        radius={[0, 3, 3, 0]}
                        name='Casos activos'
                        cursor={onExportar ? 'pointer' : undefined}
                        onClick={alClic}
                    >
                        <LabelList dataKey='casosActivos' position='right' style={{ fontSize: 11, fill: '#333' }} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}

export default CasosActivosPorProveedor
